import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';

import { environment } from '@environments/environment';
import { ApiResponse } from '@core/types';
import { PaginationConfig, PaginationResult } from '@core/services/unit.service';
import { Zone, ZoneCreate, ZoneUpdate } from '@core/types/zone.type';

@Injectable({ providedIn: 'root' })
export class ZoneService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.api}/zones`;

  grid(config: PaginationConfig): Observable<ApiResponse<PaginationResult<Zone>>> {
    let params = new HttpParams()
      .set('pageNumber', config.pageNumber.toString())
      .set('pageSize', config.pageSize.toString());

    if (config.searchTerm) {
      params = params.set('searchTerm', config.searchTerm);
    }

    return this.http.get<ApiResponse<PaginationResult<Zone>>>(`${this.baseUrl}/grid`, { params }).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        return throwError(() =>
          errorResponse.error?.validationErrors?.[0] ||
          errorResponse.error?.message ||
          'Error loading zones',
        );
      }),
    );
  }

  create(data: ZoneCreate): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(this.baseUrl, data).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        return throwError(() =>
          errorResponse.error?.validationErrors?.[0] ||
          errorResponse.error?.message ||
          'Error creating zone',
        );
      }),
    );
  }

  update(data: ZoneUpdate): Observable<ApiResponse<void>> {
    return this.http.put<ApiResponse<void>>(this.baseUrl, data).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        return throwError(() =>
          errorResponse.error?.validationErrors?.[0] ||
          errorResponse.error?.message ||
          'Error updating zone',
        );
      }),
    );
  }

  delete(id: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        return throwError(() =>
          errorResponse.error?.validationErrors?.[0] ||
          errorResponse.error?.message ||
          'Error deleting zone',
        );
      }),
    );
  }
}

